import React from 'react';
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';
import { LockOpenIcon, ChevronRightIcon, XMarkIcon } from '@heroicons/react/24/outline';

const PermisosModal = ({ permisosCurrent = [], isOpen, onClose }) => {
    console.log('permisos', permisosCurrent);

    return (
        <Transition show={isOpen} as={React.Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <TransitionChild
                    as={React.Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-[#11cdef]/50" />
                </TransitionChild>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <TransitionChild
                            as={React.Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <DialogPanel className="w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white shadow-xl transition-all">
                                {/* Header */}
                                <div className="relative border-b border-gray-200 px-6 py-4">
                                    <button
                                        onClick={onClose}
                                        className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
                                    >
                                        <XMarkIcon className="h-6 w-6" />
                                    </button>
                                    
                                    <DialogTitle className="flex items-center gap-3 font-bold text-gray-800 text-2xl" style={{ fontSize: "24px!important" }}>
                                        <LockOpenIcon className="h-6 w-6 text-[#11cdef]" />
                                        Listado de permisos asignados a este rol
                                    </DialogTitle>
                                </div>

                                {/* Lista de permisos */}
                                <div className="px-6 py-4">
                                    <div className="max-h-[60vh] overflow-y-auto">
                                        <ul className="space-y-3">
                                            {permisosCurrent && permisosCurrent.length > 0 ? (
                                                permisosCurrent.map((permiso, index) => (
                                                    <li 
                                                        key={index}
                                                        className="rounded-lg overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
                                                    >
                                                        {/* Header del permiso */}
                                                        <div className="flex items-center gap-3 bg-[#11cdef] px-4 py-3">
                                                            <LockOpenIcon className="h-5 w-5 text-white flex-shrink-0" />
                                                            <span className="font-bold text-white">
                                                                {permiso.name}
                                                            </span>
                                                        </div>
                                                        
                                                        {/* Descripción del permiso */}
                                                        <div className="flex items-start gap-2 px-4 py-3 bg-white">
                                                            <ChevronRightIcon className="h-4 w-4 text-gray-400 flex-shrink-0 mt-0.5" />
                                                            <span className="text-sm text-gray-700">
                                                                {permiso.description}
                                                            </span>
                                                        </div>
                                                    </li>
                                                ))
                                            ) : (
                                                <div className="text-center py-8 text-gray-500">
                                                    No hay permisos asignados a este rol
                                                </div>
                                            )}
                                        </ul>
                                    </div>
                                </div>

                                {/* Footer */}
                                <div className="border-t border-gray-200 px-6 py-4 flex justify-end">
                                    <button
                                        onClick={onClose}
                                        className="px-6 py-2 bg-gray-100 text-gray-700 hover:bg-gray-200 font-medium rounded-lg transition-colors duration-200"
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default PermisosModal;